var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17V19H22.5V17H2.5ZM21.5 16C21.23 11.93 18.25 8.6 14.34 7.79C14.44 7.55 14.5 7.28 14.5 7C14.5 5.9 13.6 5 12.5 5C11.4 5 10.5 5.9 10.5 7C10.5 7.28 10.56 7.55 10.66 7.79C6.75 8.6 3.77 11.93 3.5 16H21.5ZM12.5 9.58C15.45 9.58 17.97 11.41 19 13.99H6C7.03 11.41 9.55 9.58 12.5 9.58Z",
    fill: "#98A5B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiet);
export default __webpack_public_path__ + "static/media/ic_diet.f0063eb7e0d9aae659ec040ee12dad0a.svg";
export { ForwardRef as ReactComponent };